
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/useAuth";
import SupportChat from "./SupportChat";

export default function SupportChatPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) return null; // route should already be behind an auth guard, but don't render a broken chat if not

  return (
    <div className="h-screen w-full flex flex-col bg-bg">
      <SupportChat
        user={user}
        onClose={() => navigate(-1)}
        closeIcon="back"
      />
    </div>
  );
}
